import SpotTravelArticle from './SpotTravelArticle';

export default SpotTravelArticle;
